<template>
  <el-dialog
    title="打分细则"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="custom_dialog"
  >
    <el-dialog
      custom-class="custom_dialog"
      top="40px"
      :title="ruleItemForm.Id == null ? '新增细则' : '编辑细则'"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="dialog_body_box" style="max-height: 580px; overflow-y: auto">
        <el-form
          :model="ruleItemForm"
          :rules="ruleItemFormRules"
          ref="ruleItemForm"
          label-width="110px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="细则名称：" prop="Title">
            <el-input
              v-model="ruleItemForm.Title"
              autocomplete="off"
              placeholder="请输入细则名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="细则内容：" prop="Content">
            <VueUeditorWrap
              ref="contentUeditor"
              v-model="ruleItemForm.Content"
              :config="ueditorConfig"
            ></VueUeditorWrap>
          </el-form-item>
          <el-form-item label="是否打分项：" prop="IsScoringItem">
            <el-switch
              v-model="ruleItemForm.IsScoringItem"
              @change="$forceUpdate()"
            ></el-switch>
          </el-form-item>
          <el-form-item
            label="最低分数："
            prop="MinScore"
            v-show="ruleItemForm.IsScoringItem"
          >
            <el-input-number
              v-model="ruleItemForm.MinScore"
              controls-position="right"
              :min="0"
              size="mini"
              :precision="0"
              :step="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="最高分数："
            prop="MaxScore"
            v-show="ruleItemForm.IsScoringItem"
          >
            <el-input-number
              v-model="ruleItemForm.MaxScore"
              controls-position="right"
              :min="0"
              size="mini"
              :precision="0"
              :step="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="权重百分比："
            prop="ScorePercent"
            v-show="ruleItemForm.IsScoringItem"
          >
            <el-input-number
              v-model="ruleItemForm.ScorePercent"
              controls-position="right"
              :min="0"
              size="mini"
              :precision="2"
              :step="1"
            ></el-input-number>
            %
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="ruleItemForm.Sort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="editRuleItem('ruleItemForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <div class="operate_btn_box">
      <el-button type="success" @click="openEditRuleItem(null)">
        新增细则
      </el-button>
    </div>
    <el-table
      v-loading="tableLoading"
      :data="ruleItemsTable"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
      >
      </el-table-column>
      <el-table-column property="Title" label="细则名称" width="120">
      </el-table-column>
      <el-table-column label="细则内容" key="Content">
        <template slot-scope="scope">
          <span>{{ scope.row.Content }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="是否打分项"
        width="120"
        align="center"
        key="IsScoringItem"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.IsScoringItem">是</span>
          <span v-if="!scope.row.IsScoringItem">否</span>
        </template>
      </el-table-column>
      <el-table-column label="分数范围" width="90" align="center" key="Score">
        <template slot-scope="scope">
          <span v-if="scope.row.IsScoringItem">
            {{ scope.row.MinScore }}~{{ scope.row.MaxScore }}
          </span>
          <span v-if="!scope.row.IsScoringItem"> 无 </span>
        </template>
      </el-table-column>
      <el-table-column
        label="权重"
        width="90"
        align="center"
        key="ScorePercent"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.IsScoringItem">
            {{ scope.row.ScorePercent }}%
          </span>
          <span v-if="!scope.row.IsScoringItem"> 无 </span>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="50" align="center" key="Sort">
        <template slot-scope="scope">
          <span>{{ scope.row.Sort }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-link
            type="primary"
            class="cell_link"
            @click.stop
            @click="openEditRuleItem(scope.row.Id)"
          >
            编辑
          </el-link>
          <el-link
            type="primary"
            class="cell_link"
            @click.stop
            @click="deleteRuleItem(scope.row)"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_box">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="ruleItemsQuery.MaxResultCount"
        layout="total, prev, pager, next, jumper"
        :total="ruleItemsTotalCount"
      >
      </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import voteRuleApi from '../../api/vote/voteRule'
import ueditorConfig from '../../assets/js/ueditorConfig'
import VueUeditorWrap from 'vue-ueditor-wrap'
// import * as Quill from 'quill'
export default {
  name: 'EditRuleItems',
  components: {
    VueUeditorWrap
  },
  data () {
    const _this = this
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    // var validateMaxScore = (rule, value, callback) => {
    //   if (this.ruleItemForm.MinScore > value) {
    //     callback(new Error('最高分必须大于最低分！'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      tableLoading: false,
      dialogVisible: false,
      ruleItemsTotalCount: 0,
      currentPage: 1,
      ruleItemsQuery: {
        RuleId: null,
        MaxResultCount: 5,
        SkipCount: 0,
        Sorting: null
      },
      ruleItemsTable: [],
      ruleItemForm: {},
      ruleItemFormRules: {
        Title: [
          { required: true, message: '请输入细则名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        MinScore: [
          { required: true, message: '请输入最低分数', trigger: 'blur' }],
        MaxScore: [
          { required: true, message: '请输入最高分数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (_this.ruleItemForm.MinScore > value) {
                callback(new Error('最高分必须大于最低分！'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }],
        ScorePercent: [
          { required: true, message: '请输入权重百分比', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }]
      },
      innerVisible: false,
      ueditorConfig: ueditorConfig
    }
  },
  props: {

  },
  methods: {
    getRuleItem: function (ruleItemId) {
      this.openLoading()
      voteRuleApi.getRuleItem({ ruleItemId: ruleItemId }).then(data => {
        this.ruleItemForm = data
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    getRuleItmes: function () {
      this.tableLoading = true
      voteRuleApi.getRuleItmes(this.ruleItemsQuery).then(data => {
        this.ruleItemsTable = data.Items
        this.ruleItemsTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    indexMethod (index) {
      return this.ruleItemsQuery.SkipCount + index + 1
    },
    handleSizeChange (val) {
      this.ruleItemsQuery.MaxResultCount = val
      this.getRuleItmes()
    },
    handleCurrentChange (val) {
      this.ruleItemsQuery.SkipCount = (val - 1) * this.ruleItemsQuery.MaxResultCount
      this.getRuleItmes()
    },
    openEditRuleItem: function (ruleItemId) {
      this.openLoading()
      this.innerVisible = true
      if (ruleItemId) {
        this.getRuleItem(ruleItemId)
      } else {
        this.ruleItemForm = {}
        this.ruleItemForm.Id = ruleItemId
        this.ruleItemForm.RuleId = this.ruleItemsQuery.RuleId
        this.ruleItemForm.MinScore = 1
        this.ruleItemForm.MaxScore = 100
        this.ruleItemForm.ScorePercent = 100
        this.ruleItemForm.IsScoringItem = true
        this.openLoading().close()
      }
    },
    editRuleItem: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const openLoading = this.openLoading('保存中…')
          voteRuleApi.editRuleItem(this.ruleItemForm).then(data => {
            openLoading.close()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            this.innerVisible = false
            this.getRuleItmes()
          }).catch(err => {
            openLoading.close()
            return err
          })
        } else {
          return false
        }
      })
    },
    deleteRuleItem: function (row) {
      this.$confirm('确认删除细则“' + row.Title + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteRuleApi.deleteRuleItem({
          ruleItemId: row.Id
        }).then(data => {
          openLoading.close()
          this.getRuleItmes()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    openEditRuleItems: function (ruleId) {
      this.dialogVisible = true
      this.ruleItemsQuery.RuleId = ruleId
      this.ruleItemsQuery.SkipCount = 0
      this.currentPage = 1
      this.getRuleItmes()
    }
  },
  mounted () {

  },
  created () {

  }
}
</script>
<style lang="less">
</style>
